import { connect } from "react-redux";
import BrandKitSizes from "./BrandKitSizes";
import {
  fetchTeamTemplateSizesIfNeeded,
  deleteTeamTemplateSize
} from "state/entities/teamTemplateSizes/teamTemplateSizesActions";
import {
  teamTemplateSizesSelector,
  isFetchingTeamTemplateSizesSelector
} from "state/entities/teamTemplateSizes/teamTemplateSizesSelectors";
import { userIsBrandManager } from "state/currentUser/currentUserSelectors";

const mapStateToProps = (state: any) => ({
  teamId: state.ui.currentTeam?.id,
  sizes: teamTemplateSizesSelector(state),
  isFetching: isFetchingTeamTemplateSizesSelector(state),
  isBrandManager: userIsBrandManager(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchTeamTemplateSizesIfNeeded: (args: { teamId: string }) =>
    dispatch(fetchTeamTemplateSizesIfNeeded(args)),
  deleteTeamTemplateSize: (args: any) => dispatch(deleteTeamTemplateSize(args))
});

export default connect(mapStateToProps, mapDispatchToProps)(BrandKitSizes);
